/* global bootstrap */
(function(jQuery, Drupal, focusTrap) {
  'use strict';

  Drupal.behaviors.globalHeader = {
    attach: function(context, settings) {
      const mobileMenuBreakpoint = 1200;
      const $globalHeader = jQuery('.global-navbar');
      let winResizeBounce;

      const $headerRegion = $globalHeader.find('.region-header');
      const $regionHeaderNavigation = $globalHeader.find('.region-header-navigation');
      const $regionHeaderUtility = $globalHeader.find('.region-header-utility');
      const $toggleBtn = $globalHeader.find('.navbar-toggler');

      const focusTrapsOptions = {
        escapeDeactivates: false,
        clickOutsideDeactivates: true
      };

      const focusTraps = {}; // collection of focus traps
      if (window.innerWidth < mobileMenuBreakpoint) {
        focusTraps.header = focusTrap.createFocusTrap($globalHeader[0], focusTrapsOptions);
      }

      /**
       * Re-order header blocks when they change visual order
       *
       * Sort to original DOM order (data-order)
       * Then sort based on css flex order.
       */
      function headerTabIndexFix() {
        const $headerBlocks = jQuery($globalHeader.children().toArray());
        // Track the blocks' original order
        if (!$headerBlocks.first().attr('data-order')) {
          $headerBlocks.each(function(i) {
            const $block = jQuery(this);
            $block.attr('data-order', i);
          });
        }
        // sort by DOM order
        $headerBlocks
          .sort(function(a, b) {
            const $a = jQuery(a);
            const $b = jQuery(b);
            let orderA = parseInt($a.attr('data-order'));
            let orderB = parseInt($b.attr('data-order'));
            return (orderA < orderB) ? -1 : (orderA > orderB) ? 1 : 0;
          })
          // Sort by flex order
          .sort(function(a, b) {
            const $a = jQuery(a);
            const $b = jQuery(b);
            let orderA = parseInt($a.css('order'));
            let orderB = parseInt($b.css('order'));
            return (orderA < orderB) ? -1 : (orderA > orderB) ? 1 : 0;
          })
          // Re-order within the DOM to match visual order
          .appendTo($globalHeader);
      }

      /**
       * Position header collapse relative to the top so they can be absolute
       */
      function headerCollapsePinTop() {
        $regionHeaderNavigation.removeAttr('style');
        $regionHeaderUtility.removeAttr('style');

        if (window.innerWidth < mobileMenuBreakpoint) {
          var hH = $globalHeader.outerHeight(true);
          $regionHeaderNavigation.css({'top': hH + 'px'});
          var nH = $regionHeaderNavigation.outerHeight(true);
          $regionHeaderUtility.css({'top': (hH + nH) + 'px'});
        }
      }

      /**
       * EVENTS
       */

      $toggleBtn.click(function(e) {
        // change the icon and text to reflect the state
        if ($globalHeader.hasClass('open')) {
          $globalHeader.removeClass('open');
          $globalHeader.find('.menu-toggle-label').text('Menu');
        }
        else {
          $globalHeader.addClass('open');
          $globalHeader.find('.menu-toggle-label').text('Close');
        }
      });

      // Closes menu if clicked outside
      jQuery(document).on('click', function(event) {
        var $trigger = jQuery('.dropdown-container');
        // Check if click was outside
        if (!$trigger.is(event.target) && $trigger.has(event.target).length === 0) {
          // Use Native JS to trigger Bootstrap Collapse (works even if jQuery plugin fails)
          $trigger.each(function() {
            if (jQuery(this).hasClass('show')) { // Only try to hide if it's open
              var collapseInstance = new bootstrap.Collapse(this, { toggle: false });
              collapseInstance.hide();
            }
          });
        }
      });

      // trap focus when mobile menu is opened
      jQuery('.header-collapse').on('show.bs.collapse', function(e) {
        if (focusTraps.header) {
          focusTraps.header.activate();
          jQuery('.global-header').addClass('header-open');
        }
      });

      // Release focus trap when mobile menu is closed
      jQuery('.header-collapse').on('hide.bs.collapse', function(e) {
        if (focusTraps.header) {
          focusTraps.header.deactivate();
          jQuery('.global-header').removeClass('header-open');
        }
      });

      // Deactivate focus trap and collapse all children
      $globalHeader.find('.dropdown-container').on('hide.bs.collapse', function(e) {
        const $dropdown = jQuery(e.target);
        const trapId = $dropdown.attr('id');
        // collapse any children
        $dropdown.find('.collapse').collapse('hide');
        // deactivate focus trap
        if (focusTraps[trapId]) {
          focusTraps[trapId].deactivate();
        }
      });

      // Scope focus trap to the current menu on mobile
      $globalHeader.find('.dropdown-container').on('show.bs.collapse', function(e) {
        const $dropdown = jQuery(e.target);
        const focuables = [$dropdown[0], $headerRegion[0], $toggleBtn[0]];
        // adjust timing according to CSS
        const duration = parseFloat($dropdown.css('transition-duration')) * 1000;
        const delay = parseFloat($dropdown.css('transition-delay')) * 1000;


        if (window.innerWidth < mobileMenuBreakpoint) {
          setTimeout(function() {
            const trapId = $dropdown.attr('id');
            const options = {...focusTrapsOptions}; // shallow copy of default
            // prevent scrolling to the element while it moves into view
            options.preventScroll = true;
            focusTraps[trapId] = focusTrap.createFocusTrap(focuables, options);
            focusTraps[trapId].activate();
          }, (duration + delay));
        }
      });

      // Functions to run after the user has finished resizing the window.
      jQuery(window).resize(function() {
        winResizeBounce = setTimeout(function() {
          clearTimeout(winResizeBounce);
          $globalHeader.find('.collapse').collapse('hide');
          $globalHeader.find('dropdown-container').removeAttr('style');
          headerTabIndexFix();
          headerCollapsePinTop();
        }, 100);
      });

      // Document Ready.
      jQuery(document).ready(function() {
        headerTabIndexFix();
        headerCollapsePinTop();
      });
    }
  };
})(jQuery, Drupal, focusTrap);
